import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostNoItSupport4 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costNoItSupport" section="indirectCosts">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="costNoItSupport:indirectCosts" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default CostNoItSupport4;
